import { Box, Link } from '@mui/joy';
import { useTranslation } from 'react-i18next';

import { IApplySelectedSpaSkippedLine } from 'quotes/types';
import { Color, Level } from 'theme/enums';

import { getApplySelectedSpaLineLabel } from '../applyToLines';

interface IProps {
  line: Pick<IApplySelectedSpaSkippedLine, 'lineNumber' | 'quotePartId'>;
  partNumber?: string;
  onLineClick: (quotePartId: number) => void;
}

export const LineLink = ({ line, partNumber, onLineClick }: IProps) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Link
        component="button"
        level={Level.BODY_MD}
        color={Color.PRIMARY}
        sx={{
          cursor: 'pointer',
          '&:hover': { textDecoration: 'underline' },
        }}
        onClick={() => onLineClick(line.quotePartId)}
      >
        {t('labelSelectedSpaApplyLine', { line: getApplySelectedSpaLineLabel(line) })}
      </Link>
      {partNumber && (
        <>
          : <strong>{partNumber}</strong>
        </>
      )}
    </Box>
  );
};
